<template>
  <nav class="text-white max-w-xl mx-auto h-48">
    <div class="grid grid-cols-3 items-center">
      <div>
        <div v-show="$i18n.locale === 'ar'" role='button' @click='onClickLocale'>
          English
        </div>
      </div>
      <div>
        <img src="../assets/img.png" alt="Zain Logo" class="h-8 sm:h-12" />
      </div>
      <div>
        <div style="direction: rtl" v-show="$i18n.locale === 'en'" role='button' @click='onClickLocale'>
          العربية
        </div>
      </div>
    </div>

    <div v-if="!$store.state.queryIdInfoResult || $store.state.queryIdInfoResult === 'error'"></div>
    <div v-else class="flex flex-col text-center justify-center items-center h-full">
      <h1 class="mt-3 text-xl">{{ $t($store.state.navText) }}</h1>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'ZNav',
  components: {},
  methods:{
    onClickLocale(){
      this.$i18n.locale = this.$i18n.locale === 'ar' ? 'en' : 'ar'
    }
  }
}
</script>

<style scoped></style>
